import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

export const PopupCta = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("oz_popup_seen")) return;
    const t = setTimeout(() => setShow(true), 9000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setShow(false);
    sessionStorage.setItem("oz_popup_seen", "1");
  };

  const goPacks = () => {
    close();
    document.getElementById("packs")?.scrollIntoView({ behavior: "smooth" });
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 bg-black/40 backdrop-blur-sm oz-fade-up">
      <div
        data-testid="popup-cta"
        className="relative bg-white rounded-[1.75rem] max-w-md w-full p-8 md:p-10 shadow-2xl border border-[var(--oz-border)]"
      >
        <button
          data-testid="popup-close"
          onClick={close}
          className="absolute top-4 right-4 p-2 rounded-full hover:bg-[var(--oz-bg-2)] transition-colors"
          aria-label="Fermer"
        >
          <X className="w-4 h-4" />
        </button>
        <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-[var(--oz-gold)] mb-3">
          C'est le moment
        </span>
        <h3 className="font-serif text-2xl sm:text-3xl text-[var(--oz-text)] leading-tight">
          Prêt(e) à vous lancer ?
        </h3>
        <p className="mt-3 text-sm text-[var(--oz-muted)] leading-relaxed">
          Choisissez votre Pack Ozentya et commencez à développer votre activité à votre rythme.
        </p>
        <button
          data-testid="popup-cta-button"
          onClick={goPacks}
          className="mt-6 w-full inline-flex items-center justify-center px-6 py-4 rounded-full bg-[var(--oz-dark)] text-white font-semibold text-sm tracking-wide hover:bg-black transition-colors"
        >
          VOIR LES PACKS
        </button>
      </div>
    </div>
  );
};
